// Rutas donde NO debe aparecer el prompt de instalar la PWA: interrumpe la
// captura de contrasena / login.
const AUTH_PATHS = ['/login', '/reset-password', '/forgot-password']

export const shouldShowPwaPrompt = (pathname) => !AUTH_PATHS.includes(pathname)
